import Category from './category';
import Company from './company';
import Franchise from './franchise';
import Menu from './menu';
import Modifier from './modifier';
import ModifierGroup from './modifier-group';
import Order from './order';
import Product from './product';
import Profile from './profile';
import PromoCode from './promo-code';
import ScheduleExceptions from './schedule-exception';
import SmartPricing from './smart-pricing';
import SubscriptionProduct from './subscription-product';
import SubscriptionProductPrice from './subscription-product-price';
import Variant from './variant';
import Reservation from './reservation';
import Marketing from './marketing';
import MobileApp from './mobile-app';
import PushNotifications from './push-notifications';
import Storefront from './storefront';
import PaymentGateways from './payment-gateways';
import ProcessingFees from './processing-fees';

export default {
  Category,
  Company,
  Franchise,
  Menu,
  Modifier,
  ModifierGroup,
  Order,
  Product,
  Profile,
  PromoCode,
  ScheduleExceptions,
  SmartPricing,
  SubscriptionProduct,
  SubscriptionProductPrice,
  Variant,
  Reservation,
  Marketing,
  MobileApp,
  PushNotifications,
  Storefront,
  PaymentGateways,
  ProcessingFees,
};
